<template>
  <div>
    <div class="pt-3 form-col">
      <Stepper active-step="4" />

      <section class="mb-5">
        <header>
          <h3 class="font-size-h3 font-marat c-gray">{{ $content.your_subscription }}</h3>
        </header>

        <div class="mt-2 p-4 c-bg-white b-shadow">
          <h4 class="font-size-h3 font-marat">
            <span v-if="selectedPlan.type === 'paper'" >{{ $content.paper_plan }}</span>
            <span v-else-if="selectedPlan.type === 'digital'">{{ $content.digital_plan }}</span>
            <span v-else-if="selectedPlan.type === 'special'">{{ selectedPlan.excerpt }}</span>
          </h4>

          <p v-if="selectedPlan.type !== 'special'" class="t-uppercase mt-2">{{ selectedPlan.excerpt }}</p>

          <p v-if="selectedPlan.post_type === 'subscription_chain'"
             class="font-marat font-size-h3 c-black t-bold mt-3 mb-3">
              {{ selectedPlan.price_desc }}
          </p>
          <p v-else class="font-marat font-size-h3 c-black t-bold mt-3 mb-3">
            {{ selectedPlan.price | toPrice }} zł <span v-if="selectedPlan.is_cyclical === '1'">{{ $content.every_month }}</span>
          </p>

          <p v-if="selectedPlan.price_desc_2 !== ''" class="c-gray">{{ selectedPlan.price_desc_2 }}</p>

          <div v-if="selectedPlan.type !== 'special'">
            <template v-if="giftData.isGift">
              <p class="c-gray">{{ $content.validity_period }}: </p>
              <p>{{ $content.gift_period }}</p>
              <p class="c-pink mt-2">{{ $content.gift_alert}}</p>
            </template>

            <template v-else>
              <p class="c-gray">{{ $content.validity_period }}: </p>

              <template v-if="selectedPlan.post_type === 'subscription_chain'">
                <p>{{ selectedPlan.price_info }}
                    <br/>{{ $content.mit_renewing_info }}
                </p>
              </template>

              <template v-else-if="selectedPlan.is_cyclical === '1'">
                <p>{{ $content.auto_renewal }}<br/>{{ $content.quit_whenever }}</p>
              </template>

              <template v-else>
                <p class="t-lining-nums t-normal font-size-h6" v-if="planPeriod">
                  {{ planPeriod.duration_period_start | formatDate }} – {{ planPeriod.duration_period_end | formatDate }}</p>
              </template>
            </template>
          </div>

          <div class="plan-description font-size-h6 mt-3"
               v-html="selectedPlan.full_description"></div>
        </div>
      </section>

      <template v-if="!plansAlwaysAvailable && blockPurchase">
        <div v-if="cyclicalOn">
          <p class="c-pink font-size-h6">{{ $content.cancel_cyclical }}</p>
          <a :href="PROFILE_URL"
             class="btn btn-primary btn-max ml-a mt-2 mr-a">{{ $content.my_profile }}</a>
        </div>
        <div v-else>
          <p class="c-pink font-size-h6">{{ $content.next_purchase_info }}</p>
          <a :href="PROFILE_URL"
             class="btn btn-primary btn-max ml-a mt-2 mr-a">{{ $content.my_profile }}</a>
        </div>
      </template>

      <template v-else>
        <div v-if="giftData.isGift">
          <section class="mb-6">
            <header class="form-legend bb-1 pb-2 mb-4">
              <h3 class="font-size-h3 c-gray">{{ $content.gift_delivery_method }}</h3>
            </header>
            <div class="pl-6 pr-6">
              <p class="checkMark">
                <span v-if="giftData.deliveryMethod === 'sendEmail'">{{ $content.sendCoupon }}</span>
                <span v-else>{{ $content.printCoupon }}</span>
              </p>
            </div>
          </section>

          <section>
            <header class="form-legend bb-1 pb-1 mb-4">
              <h3 class="font-size-h3 c-gray">{{ $content.gift_for}}</h3>
            </header>
            <div class="pl-6 pr-6">
              <dl class="flex">
                <div>
                  <dt>{{ $content.name }}:</dt>
                  <dd>{{ giftData.name }}</dd>
                </div>
                <template v-if="giftData.deliveryMethod === 'sendEmail'">
                  <div>
                    <dt>{{ $content.emailAddress }}:</dt>
                    <dd>{{ giftData.email }}</dd>
                  </div>
                  <div>
                    <dt>{{ $content.dedication }}:</dt>
                    <dd>{{ giftData.message }}</dd>
                  </div>
                </template>
              </dl>
            </div>
          </section>
        </div>

        <div v-else>
          <div v-if="selectedPlan.is_shipping">
            <section class="mb-5">
              <header class="form-legend bb-1 pb-1 mb-4">
                <h3 class="font-size-h3 c-gray">{{ $content.delivery_method }}</h3>
              </header>
              <div class="pl-6 pr-6">
                <p class="checkMark">
                  <span v-if="$store.state.deliveryMethod === 'paczkaWRuchu'">{{ $content.paczka_wruchu }}</span>
                  <span v-else>{{ $content.poczta_polska }}</span>
                </p>
              </div>
            </section>

            <section class="mb-5">
              <header>
                <h3 class="form-legend font-size-h3 font-marat c-gray bb-1 pb-1 mb-4">{{ $content.deliveryData }}</h3>
              </header>
              <div class="pl-6 pr-6">
                <dl class="flex">
                  <div>
                    <dt>{{ $content.first_name }}:</dt>
                    <dd>{{ addressData.firstname }}</dd>
                  </div>
                  <div>
                    <dt>{{ $content.last_name }}:</dt>
                    <dd>{{ addressData.lastname }}</dd>
                  </div>
                  <div v-if="addressData.company">
                    <dt>{{ $content.company_name }}:</dt>
                    <dd>{{ addressData.company }}</dd>
                  </div>
                  <div v-if="addressData.phone">
                    <dt>{{ $content.phone }}:</dt>
                    <dd>{{ addressData.phone }}</dd>
                  </div>
                  <div>
                    <dt>{{ $content.street }}:</dt>
                    <dd>{{ addressData.street }}</dd>
                  </div>
                  <div>
                    <dt>{{ $content.street_number }}:</dt>
                    <dd>{{ addressData.streetnumber }}</dd>
                  </div>
                  <div v-if="addressData.apartamentnumber">
                    <dt>{{ $content.apartment_number }}:</dt>
                    <dd>{{ addressData.apartamentnumber }}</dd>
                  </div>
                  <div>
                    <dt>{{ $content.zip_code }}:</dt>
                    <dd>{{ addressData.postcode }}</dd>
                  </div>
                  <div>
                    <dt>{{ $content.city }}:</dt>
                    <dd>{{ addressData.city }}</dd>
                  </div>
                  <div v-if="selectedPlan.is_abroad">
                    <dt>{{ $content.country }}:</dt>
                    <dd>{{ addressData.country }}</dd>
                  </div>
                  <div v-else>
                    <dt>{{ $content.country }}:</dt>
                    <dd>{{ $content.poland }}</dd>
                  </div>
                </dl>
              </div>
            </section>
          </div>
        </div>

        <ValidationObserver v-slot="{ handleSubmit }" @submit.prevent tag="div">
          <section class="mb-5">
            <header>
              <h3 class="form-legend font-size-h3 font-marat c-gray bb-1 pb-1 mb-4">{{ $content.invoice }}</h3>
            </header>

            <div class="pl-6 pr-6">
              <div class="pl-1">
                <ValidationProvider>
                  <label class="checkbox">
                    <input type="checkbox" v-model="invoiceNeeded">
                    <span class="check"></span>{{ $content.invoice_needed }}
                  </label>
                </ValidationProvider>
              </div>

              <transition name="fade" mode="out-in">
                <form
                  v-show="invoiceNeeded"
                  class="mt-4"
                >
                  <div class="form-row">
                    <div class="form-field form-required mb-4">
                      <label for="invoiceCompanyName" class="label">{{ $content.company_name }}:</label>
                      <ValidationProvider mode="lazy" :rules="`${ invoiceNeeded ? 'required' : '' }`" v-slot="{ errors }">
                        <input id="invoiceCompanyName" class="form-control" type="text"
                               v-model="invoiceCompanyName"/>
                        <p class="form-error">{{ errors[0] }}</p>
                      </ValidationProvider>
                    </div>

                    <div class="form-field form-required mb-4">
                      <label for="invoiceTaxID" class="label">{{ $content.tax_id }}:</label>
                      <ValidationProvider mode="lazy" :rules="`${ invoiceNeeded ? 'required|nip' : '' }`" v-slot="{ errors }">
                        <input id="invoiceTaxID" class="form-control" type="text"
                               v-model="invoiceTaxID"/>
                        <p class="form-error">{{ errors[0] }}</p>
                      </ValidationProvider>
                    </div>

                    <div class="form-field form-required mb-4">
                      <label for="invoiceStreet" class="label">{{ $content.street }}:</label>
                      <ValidationProvider mode="lazy" :rules="`${ invoiceNeeded ? 'required' : '' }`" v-slot="{ errors }">
                        <input id="invoiceStreet" class="form-control" type="text"
                               v-model="invoiceStreet"/>
                        <p class="form-error">{{ errors[0] }}</p>
                      </ValidationProvider>
                    </div>

                    <div class="form-field form-required mb-4">
                      <label for="invoiceStreetNumber" class="label">{{ $content.street_number}}:</label>
                      <ValidationProvider mode="lazy" :rules="`${ invoiceNeeded ? 'required' : '' }`" v-slot="{ errors }">
                        <input id="invoiceStreetNumber" class="form-control" type="text"
                               v-model="invoiceStreetNumber"/>
                        <p class="form-error">{{ errors[0] }}</p>
                      </ValidationProvider>
                    </div>

                    <div class="form-field mb-4">
                      <label for="invoiceApartmentNumber" class="label">{{ $content.apartment_number }}:</label>
                      <input id="invoiceApartmentNumber" class="form-control" type="text"
                             v-model="invoiceApartmentNumber"/>
                    </div>

                    <div class="form-field form-required mb-4">
                      <label for="invoiceZipCode" class="label">{{ $content.zip_code }}:</label>
                      <ValidationProvider mode="lazy" :rules="`${ invoiceNeeded ? 'required' : '' }`" v-slot="{ errors }">
                        <input id="invoiceZipCode" class="form-control" type="text"
                               v-model="invoiceZipCode"/>
                        <p class="form-error">{{ errors[0] }}</p>
                      </ValidationProvider>
                    </div>

                    <div class="form-field form-required mb-4">
                      <label for="invoiceCity" class="label">{{ $content.city }}:</label>
                      <ValidationProvider mode="lazy" :rules="`${ invoiceNeeded ? 'required' : '' }`" v-slot="{ errors }">
                        <input id="invoiceCity" class="form-control" type="text"
                               v-model="invoiceCity"/>
                        <p class="form-error">{{ errors[0] }}</p>
                      </ValidationProvider>
                    </div>

                  </div>
                </form>
              </transition>
            </div>
          </section>

          <section class="mb-5">
            <header class="form-legend bb-1 pb-1 mb-4">
              <h3 class="font-size-h3 c-gray">{{ $content.payment_method }}</h3>
            </header>
            <div>
              <img
                class="vendors"
                :src="require(`@/assets/images/payments-${selectedPlan.is_cyclical === '1' || selectedPlan.post_type === 'subscription_chain' ? 'espago' : 'przelewy'}.png`)" alt="" />

              <template v-if="selectedPlan.is_cyclical === '1' || selectedPlan.post_type === 'subscription_chain'">
                <p class="mt-2 c-gray">{{ $content.fill_card_info }}</p>
                <p class="mt-2 c-gray">{{ $content.fill_card_info_2 }}</p>
                <EspagoCardForm
                  v-if="$appInfo.ESPAGO.embedded_card_form" 
                  v-bind:payment_in_progress="paymentInProgress"
                  >
                </EspagoCardForm>
                <a v-else class="btn btn-outline-primary btn-max mt-1" :href="CARD_REDIRECT_URL">{{ $content.fill_card }}</a>
                <p v-show="fillCardError" class="c-pink mt-2">{{ $content.fill_card_error }}</p>
                <p v-show="paymentError" class="c-pink mt-2">{{ $content.payment_error }}</p>
              </template>

              <template v-else>
                <ValidationProvider tag="fieldset" rules="required" v-slot="{ errors }" class="mt-2">
                  <div class="flex flex-justify-center flex-wrap pl-6 pr-6">
                    <div class="radio-card b-shadow" :class="{ active: paymentMethod === 'cardPayment'}">
                      <label class="radioControl">
                        <input type="radio" name="paymentMethod" value="espago" v-model="paymentMethod">
                        <span class="radio"></span>
                        {{ $content.card_payment }}
                      </label>
                    </div>
                    <div
                      v-if="selectedPlan.is_cyclical !== '1'"
                      class="radio-card b-shadow"
                      :class="{ active: paymentMethod === 'bankTransfer'}">
                      <label class="radioControl">
                        <input type="radio" name="paymentMethod" value="przelewy24" v-model="paymentMethod">
                        <span class="radio"></span>
                        {{ $content.bank_transfer }}
                      </label>
                    </div>
                  </div>
                  <EspagoCardForm 
                    v-if="$appInfo.ESPAGO.embedded_card_form && paymentMethod === 'espago'" 
                    v-bind:payment_in_progress="paymentInProgress"
                    >
                  </EspagoCardForm>
                  <div class="pl-6 pr-6">
                    <p class="form-error">{{ errors[0] }}</p>
                  </div>
                </ValidationProvider>
                <p v-show="paymentError" class="c-pink mb-3">{{ $content.payment_error }}</p>
              </template>

            </div>
          </section>
          <hr/>
          <section class="mt-4 mb-4">
            <div class="pl-6 pr-6">
                <p v-if="cyclicalKind === true" class="c-pink" style="margin-bottom: 20px;">{{ $content.cyclical_kind_instruction }}</p>
              <ValidationProvider :rules="{ required: { allowFalse: false } }" v-slot="{ errors }">
                <label class="checkbox">
                  <input type="checkbox" v-model="termsAccepted">
                  <span class="check"></span>
                  <span>{{ $content.payment_terms[0] }} <a class="c-pink terms" href="/regulamin" target="_blank">{{ $content.payment_terms[1] }}</a>{{ $content.payment_terms[2] }} <a class="c-pink terms" href="/warunki-sprzedazy" target="_blank">{{ $content.payment_terms[3]}}</a>{{$content.payment_terms[4] }}*</span>
                </label>
                <p class="form-error">{{ errors[0] }}</p>
              </ValidationProvider>
              <small class="d-inline c-gray mt-1">{{ $content.required_field }}</small>
            </div>
          </section>

          <template v-if="selectedPlan.is_cyclical === '1'">            
            <div class="flex flex-justify-center">
              <button v-if="!cardTokenReceived"
                class="btn btn-primary btn-max"
                :class="{ 'btn--loading': paymentInProgress }"
                @click="handleSubmit(purchaseCyclicalPlan)"
              >
                <span class="loader" v-if="paymentInProgress"></span>
                <span v-else>{{ $content.pay }}</span>
              </button>
              <a class="btn btn-primary btn-max" :href="cardActionData.button_href" v-else>{{ cardActionData.button_name }}</a>
            </div>
            <div class="flex flex-justify-center">
              <p class="form-error">{{ cardActionData.response_message }}</p>        
            </div>
          </template>

          <template v-else>
            <form
              v-if="paymentForm"
              ref="paymentForm"
              id="paymentForm"
              :action="paymentForm.action"
              :method="paymentForm.method">
              <input v-for="(value, key, index) in paymentForm.fields"
                     readonly
                     type="hidden"
                     :id="key"
                     :key="index"
                     :name="key"
                     :value="value"/>
              <input id="nonce" v-if="paymentForm.nonce" readonly type="hidden" :value="paymentForm.nonce">
            </form>

            <div class="flex flex-justify-center">
              <button v-if="!cardTokenReceived"
                class="btn btn-primary btn-max"
                @click="handleSubmit(submitPayment)"
                :disabled="!paymentForm"
                :class="{ 'btn--loading': paymentInProgress }"
                form="paymentForm"
              >
                <span class="loader" v-if="paymentInProgress"></span>
                <span v-else>{{ $content.pay }}</span>
              </button>
              <a class="btn btn-primary btn-max" :href="cardActionData.button_href" v-else>{{ cardActionData.button_name }}</a>
            </div>
            <div class="flex flex-justify-center">
              <p class="form-error">{{ cardActionData.response_message }}</p>        
            </div>
          </template>

        </ValidationObserver>
      </template>


    </div>
  </div>
</template>

<script>
  import { ValidationProvider, ValidationObserver  } from 'vee-validate';
  import { mapGetters } from 'vuex';
  import FiltersMixin from '../../mixins/filters';
  import UserDataMixin from '../../mixins/userdata';
  import Stepper from './Stepper';
  import EspagoCardForm from './../EspagoCardForm';

  const PRZELEWY24 = 'przelewy24';
  const ESPAGO = 'espago';
  const CARD_REDIRECT_URL = '/wp-admin/admin-ajax.php?action=edit_espago_user_card&redirect=prenumerata';
  const PROFILE_URL = '/panel/moj-profil/';

  export default {
    components: { Stepper, ValidationProvider, ValidationObserver, EspagoCardForm },
    mixins: [ FiltersMixin, UserDataMixin ],
    mounted() {
      if (!this.giftData.isGift) this.fetchPlanData();
      this.$store.commit('setPaymentMethod', {paymentMethod: '' });
    },
    data() {
      return {
        invoiceNeeded: false,
        termsAccepted: false,
        paymentError: false,
        fillCardError: false,
        paymentInProgress: false,
        cardTokenReceived: false,
        cyclicalKind: null,
        alternative_Cyclical_plan: null,
        cardActionData: {
          button_name: '',  
          button_href: '#',
          response_message: ''
        },
        paymentForm: null,
        planPeriod: null,
        CARD_REDIRECT_URL,
        PROFILE_URL
      }
    },
    computed: {
      paymentMethod: {
        get () {
          return this.$store.state.paymentMethod
        },
        set (value) {
          this.$store.commit('setPaymentMethod', {paymentMethod: value })
        }
      },
      invoiceCompanyName: {
        get () {
          if (this.invoiceData && this.invoiceData.company) {
            return this.invoiceData.company
          } else {
            return ''
          }
        },
        set (value) {
          this.$store.commit('setInvoiceCompanyName', {invoiceCompanyName: value })
        }
      },
      invoiceTaxID: {
        get () {
          if (this.invoiceData && this.invoiceData.nip) {
            return this.invoiceData.nip
          } else {
            return ''
          }
        },
        set (value) {
          this.$store.commit('setInvoiceTaxID', {invoiceTaxID: value })
        }
      },
      invoiceStreet: {
        get () {
          if (this.invoiceData && this.invoiceData.street) {
            return this.invoiceData.street
          } else {
            return ''
          }
        },
        set (value) {
          this.$store.commit('setInvoiceStreet', {invoiceStreet: value })
        }
      },
      invoiceStreetNumber: {
        get () {
          if (this.invoiceData && this.invoiceData.streetnumber) {
            return this.invoiceData.streetnumber
          } else {
            return ''
          }
        },
        set (value) {
          this.$store.commit('setInvoiceStreetNumber', {invoiceStreetNumber: value })
        }
      },
      invoiceApartmentNumber: {
        get () {
          if (this.invoiceData && this.invoiceData.apartamentnumber) {
            return this.invoiceData.apartamentnumber
          } else {
            return ''
          }
        },
        set (value) {
          this.$store.commit('setInvoiceApartmentNumber', {invoiceApartmentNumber: value })
        }
      },
      invoiceZipCode: {
        get () {
          if (this.invoiceData && this.invoiceData.postcode) {
            return this.invoiceData.postcode
          } else {
            return ''
          }
        },
        set (value) {
          this.$store.commit('setInvoiceZipCode', {invoiceZipCode: value })
        }
      },
      invoiceCity: {
        get () {
          if (this.invoiceData && this.invoiceData.city) {
            return this.invoiceData.city
          } else {
            return ''
          }
        },
        set (value) {
          this.$store.commit('setInvoiceCity', {invoiceCity: value })
        }
      },
      invoiceCountry: {
        get () {
          if (this.invoiceData && this.invoiceData.country) {
            return this.invoiceData.country
          } else {
            return ''
          }
        },
        set (value) {
          this.$store.commit('setInvoiceCountry', {invoiceCountry: value })
        }
      },
      alternativeCyclicalPlanExists() {
            if (this.selectedPlan.cyclical_version_plan_id == null || this.selectedPlan.cyclical_version_plan_id == '') {
               return false;
            }
            return window.APP_INFO.init.cyclical_versions[this.selectedPlan['subscription_type']] != null &&
             window.APP_INFO.init.cyclical_versions[this.selectedPlan['subscription_type']][this.selectedPlan['period_months']] != null &&
             window.APP_INFO.init.cyclical_versions[this.selectedPlan['subscription_type']][this.selectedPlan['period_months']][this.selectedPlan.cyclical_version_plan_id] != null
        },
      plansAlwaysAvailable() {
        return this.selectedPlan.type === 'special' || this.giftData.isGift;
      },
      blockPurchase() {
        return !!(this.hasCyclicalSubscription || !this.subscriptionExpiresInTwoWeeks);
      },
      cyclicalOn() {
        return !!this.hasCyclicalSubscription;
      },
      ...mapGetters({
        selectedPlan: 'GET_SELECTED_PLAN',
        giftData: 'GET_GIFT_DATA',
        addressData: 'GET_USER_ADDRESS',
        invoiceData: 'GET_USER_INVOICE',
        userSubscriptionType: 'GET_USER_SUBSCRIPTION_TYPE',
        userSubscriptionUnlocked: 'GET_USER_SUBSCRIPTION_EXPIRES_IN_TWO_WEEKS',
        hasCyclicalSubscription: 'GET_USER_CYCLICAL_SUBSCRIPTION_ON',
        subscriptionExpiresInTwoWeeks: 'GET_USER_SUBSCRIPTION_EXPIRES_IN_TWO_WEEKS'
      })
    },
    methods: {
        gtmSendPaymentInfo(isGift) {
            const period = this.selectedPlan.period_months == 12 ? 'r' : (this.selectedPlan.period_months == 1 ? 'm' : 'i');

            let item_categories = {
                subscription: {
                    r: 'Prenumerata roczna',
                    m: 'Prenumerata miesięczna',
                    i: 'Prenumerata inna'
                },
                access: {
                    r: 'Dostęp roczny',
                    m: 'Dostęp miesięczny',
                    i: 'Dostęp inny'
                },
                chain: {
                    subscription: 'Prenumerata odawialna',
                    access: 'Dostęp odnawialny'
                }
            };

            let item_category = '';

            switch (this.selectedPlan.post_type) {
                case 'subscription_plan':
                    item_category = this.selectedPlan.is_shipping ?
                            item_categories.subscription[period] :
                            item_categories.access[period];
                break;
                case 'subscription_chain':
                    item_category = this.selectedPlan.is_shipping ?
                            item_categories.chain.subscription :
                            item_categories.chain.access;
                break;
                case 'coupon_gift':
                    item_category = this.selectedPlan.is_shipping ?
                            item_categories.subscription[period] :
                            item_categories.access[period];
            }

            this.$gtm.trackEvent({
                event: 'add_payment_info',
                category: 'prenumerata',
                action: 'click',
                label: this.selectedPlan.title,
                value: this.selectedPlan.price,
                ecommerce: {
                    payment_type: this.paymentMethod == 'ESPAGO' ? 'Karta kredytowa lub debetowa' : 'Przelew',
                    items: [{
                        item_name: this.selectedPlan.title,
                        item_id: this.selectedPlan.ID,
                        price: this.selectedPlan.price,
                        item_category: item_category,
                        item_variant: isGift ? 'Na prezent' : 'Dla siebie',
                        promotion_id: '',
                        promotion_name: ''
                    }]
                }
            });
        },
        checkPossiblePayment(value) {
            if (value === 'cyclical') {
                this.paymentMethod = 'none';
            }
        },
      async fetchPlanData() {
        const { data } = await this.$http.post(`/wp-admin/admin-ajax.php?action=get_single_plan&plan_id=${this.selectedPlan.ID}`);
        if (data.error) {
          throw 'Error fetching plan data'
        }
        if (data.plan.post_type === 'subscription_chain') {
            this.paymentMethod = 'espago';
        }
        this.planPeriod = data.plan_period;
      },
      async newGiftOrder() {
        const recipientData = {
          'gift_recipient_address[email]': this.giftData.email,
          'gift_recipient_address[firstname]': this.giftData.name,
          'gift_recipient_address[lastname]': '',
          'gift_recipient_address[message]': this.giftData.message
        };
        let encodedRecipientData = this.toQueryString(recipientData);

        const formData = new FormData();
        formData.append('coupon_id', this.selectedPlan.coupon_id);
        formData.append('session_id', this.paymentForm.fields.session_id);
        formData.append('form', encodedRecipientData);
        formData.append('vue', 'true');

        if (this.giftData.deliveryMethod === 'sendEmail') {
          formData.append('recipient_email_on', '1');
        } else {
          formData.append('recipient_email_on', '0');
        }

        if (this.invoiceNeeded) {
          formData.append('invoice_cb', '1');
        } else {
          formData.append('invoice_cb', '0');
        }

        if (this.paymentForm.fields.nonce) {
          formData.append('nonce', this.paymentForm.fields.nonce);
        } else {
          formData.append('nonce', this.paymentForm.nonce);
        }

        const { data } = await this.$http.post('/wp-admin/admin-ajax.php?action=new_gift_order', formData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });
        if (data === 0 || data.state === 'error') {
          throw 'Error when creating new gift order'
        }
        this.gtmSendPaymentInfo(this.giftData.isGift);
        return data
      },
      async submitPayment() {
        let promiseArr = [];
        this.paymentInProgress = true;
        this.$store.commit('saveUserInSession');

        if (this.selectedPlan.type !== 'digital' && !this.giftData.isGift) {
          promiseArr.push(this.updateAddressData());
        }

        if (this.invoiceNeeded) {
          promiseArr.push(this.updateInvoiceData());
        }

        if (this.giftData.isGift) {
          promiseArr.push(this.newGiftOrder());
        }

        Promise.all(promiseArr)
          .then(() => {
            const formData = new FormData();
            const vm = this;
            switch (this.paymentMethod) {
              case ESPAGO:
                if (this.$appInfo.ESPAGO.embedded_card_form) {
                  this.saveESPAGOCard();
                } else {
                  this.gtmSendPaymentInfo(this.giftData.isGift);
                this.$refs.paymentForm.submit();
                }
                break;

              case PRZELEWY24:
                if (this.giftData.isGift) {
                  formData.append('coupon_id', this.paymentForm.fields.coupon_id);
                } else {
                  formData.append('plan_id', this.paymentForm.fields.plan_id);
                }
                formData.append('nonce', this.paymentForm.fields.nonce);
                formData.append('invoice_cb', this.paymentForm.fields.invoice_cb);
                formData.append('session_id', this.paymentForm.fields.session_id);
                formData.append('vue', 'true');

                this.$http.post(this.paymentForm.action, formData)
                  .then(res => {
                    if (!res.data.url || res.data.url === '0') {
                      this.paymentError = true;
                      this.paymentInProgress = false;
                      return false
                    } else {
                      vm.gtmSendPaymentInfo(vm.giftData.isGift);
                      setTimeout(() => {
                        window.location.href = res.data.url;
                      }, 500);
                    }
                  })
                  .catch(e => {
                    console.log(e.message);
                    this.paymentError = true;
                    this.paymentInProgress = false;
                  });
                break;
            }
          })
          .catch(e => {
            console.log(e);
            this.paymentError = true;
            this.paymentInProgress = false;
          });
      },
      saveESPAGOCard() {
        let espago = new window.Espago({
            public_key: this.$appInfo.ESPAGO.public_key, 
            custom: true, 
            live: true,
            submit: false}
        );
        
        let is_espago_card_error = false;
        
        let $espago_card_number_error = document.getElementById('espago_card_number_error');
        if (espago.validate_card_number()) { 
            $espago_card_number_error.innerHTML = '';
        } else {
            $espago_card_number_error.innerHTML = 'Błędne dane';
            is_espago_card_error = true;
        }
        
        let $espago_first_name_error = document.getElementById('espago_first_name_error');
        if (espago.validate_first_name()) {            
            $espago_first_name_error.innerHTML = '';
        } else {
            $espago_first_name_error.innerHTML = 'Błędne dane';
            is_espago_card_error = true;
        }        

        let $espago_last_name_error = document.getElementById('espago_last_name_error');
        if (espago.validate_last_name()) {
            $espago_last_name_error.innerHTML = '';
        } else {
            $espago_last_name_error.innerHTML = 'Błędne dane';
            is_espago_card_error = true;
        }        

        let $espago_year_error = document.getElementById('espago_year_error');
        if (espago.validate_card_date()) {
            $espago_year_error.innerHTML = '';
        } else {
            $espago_year_error.innerHTML = 'Błędne dane';
            is_espago_card_error = true;
        }        

        let $espago_verification_value_error = document.getElementById('espago_verification_value_error');
        if (espago.validate_card_cvc()) {
            $espago_verification_value_error.innerHTML = '';
        } else {
            $espago_verification_value_error.innerHTML = 'Błędne dane';
            is_espago_card_error = true;
        }

        if (is_espago_card_error) {
            this.paymentInProgress = false;
            return;
        }

        espago.create_token();
        
        const vm = this;
        
        let token_listener = null;
          token_listener = setInterval(function () {
            let card_token = document.getElementById('espagoCard').value;

            if (card_token != '') {
              clearInterval(token_listener);

              let formData = new FormData();
              if (vm.selectedPlan.post_type === 'subscription_chain') {
                formData.append("action", 'mit_card_storing');
                formData.append('chain_wp_id', vm.selectedPlan.ID);
              } else {
                formData.append("action", 'charges_and_card_storing');
              }

              if(vm.giftData.isGift) {
                  formData.append('coupon_id', vm.selectedPlan.coupon_id);
                  formData.append('session_id', vm.paymentForm.fields.session_id);
              }

              if (vm.alternativeCyclicalPlanExists) {
                formData.append(
                  'espago_plan_id',
                  window.APP_INFO.init.cyclical_versions[vm.selectedPlan['subscription_type']][vm.selectedPlan['period_months']][vm.selectedPlan.cyclical_version_plan_id]['espago_plan_id']
                );
              } else {
                formData.append('espago_plan_id', vm.selectedPlan.espago_plan_id);
              }
              formData.append('card_token', card_token);
              
              if (this.invoiceNeeded) {
                formData.append('invoice_cb', '1');
              } {
                formData.append('invoice_cb', '0');
              }
             
              let xhr = new XMLHttpRequest();
              xhr.onreadystatechange = function () {
                if (xhr.readyState == 4 && xhr.status == 200) {
                    let responseObject = JSON.parse(xhr.responseText);
                    console.log(responseObject)
                    if (responseObject.redirect_url != null) {
                      vm.gtmSendPaymentInfo(vm.giftData.isGift);
                      vm.cardTokenReceived = true;
                      vm.cardActionData.button_name = responseObject.redirect_name;
                      vm.cardActionData.button_href = responseObject.redirect_url;                
                      window.location.href = responseObject.redirect_url;
                    } else {
                        vm.paymentInProgress = false;
                        vm.cardActionData.response_message = responseObject.error;
                    }
                }
              }
              xhr.open("POST", "/wp-admin/admin-ajax.php", true);
              xhr.send(formData);
            }
            }, 500)
      },
      async purchaseCyclicalPlan() {
        let promiseArr = [];
        this.paymentInProgress = true;
        this.$store.commit('saveUserInSession');

        if (this.selectedPlan.type !== 'digital' && !this.giftData.isGift) {
          promiseArr.push(this.updateAddressData());
        }

        if (this.invoiceNeeded) {
          promiseArr.push(this.updateInvoiceData());
        }

        Promise.all(promiseArr)
          .then(() => {     
              if (this.$appInfo.ESPAGO.embedded_card_form) {
                  this.saveESPAGOCard();
              } else {
            let formData = new FormData();
            formData.append('plan_id', this.selectedPlan.espago_plan_id );
            formData.append('vue', 'true');

            if (this.invoiceNeeded) {
              formData.append('invoice_cb', '1');
            } {
              formData.append('invoice_cb', '0');
            }
            this.$http.post('/wp-admin/admin-ajax.php?action=new_user_payment_card_cyclical', formData)
              .then(res => {
                if (res.data.url) {
                  setTimeout(() => {
                    window.location.href = res.data.url;
                  }, 500);
                } else {
                  this.fillCardError = true;
                  this.paymentInProgress = false;
                }
              });
              }  
          })
          .catch(e => {
            this.paymentError = true;
            this.paymentInProgress = false;
            console.log(e);
          });
      },
      fetchSinglePaymentForm(method) {
        let formData = new FormData();

        if (this.giftData.isGift) {
          formData.append( 'coupon_id', this.selectedPlan.coupon_id );
        } else {

            if (this.alternativeCyclicalPlanExists && method === 'espago') {
                this.cyclicalKind = true;
                formData.append(
                    'plan_id',
                    this.selectedPlan.cyclical_version_plan_id
                );
            } else {
                this.cyclicalKind = false;

                formData.append( 'plan_id', this.selectedPlan.ID );
            }

        }
        formData.append('vue', 'true');

        switch (method) {
          case ESPAGO:
            this.$http.post('/wp-admin/admin-ajax.php?action=app_espago_single_payment_form', formData)
              .then( res => {
                this.paymentForm = res.data.form;
                this.paymentForm.fields.vue = true;
              });
            break;

          case PRZELEWY24:
            this.$http.post('/wp-admin/admin-ajax.php?action=app_przelewy24_single_payment_form', formData)
              .then(res => {
                this.paymentForm = res.data.form;
                this.paymentForm.fields.vue = true;
                if (this.invoiceNeeded) {
                  this.setInvoice(true);
                }
              });
            break;

          default:
            break;
        }
      },
      setInvoice(isChecked) {
        if (this.paymentForm && isChecked) {
          this.paymentForm.fields.invoice_cb = 1;
        } else {
          this.paymentForm.fields.invoice_cb = 0;
        }
      }
    },
    watch: {
      paymentMethod(val, oldVal) {
        switch (val) {
          case ESPAGO:
            this.fetchSinglePaymentForm(val);
            break;
          case PRZELEWY24:
            this.fetchSinglePaymentForm(val);
            break;
          default:
            break;
        }
      },
      invoiceNeeded(val, oldVal) {
        if (this.paymentForm !== null ) {
          if (val && this.paymentMethod === PRZELEWY24) {
            this.setInvoice(true)
          } else {
            this.setInvoice(false)
          }
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../../scss/mixins';
  dl {
    margin: 0;
    flex-wrap: wrap;
    > div {
      padding-left: 10px;
      padding-right: 10px;
      margin-bottom: 2em;
      width: 100%;
      @include respond-to('desktop') {
        width: 50%;
      }
    }
    dt { color: var(--color-gray); }
    dd { margin-left: 0; }
  }

  .vendors {
    max-width: 340px;
  }

  .terms {
    margin-left: 3px;
    margin-right: 3px;
  }
</style>
